import ratingSlider from "surveylabJsAssets/page/_rating-slider";

// noinspection JSUnusedGlobalSymbols
export default function () {
    ratingSlider.initOnce();
}